// Quiet sponsor credit near the top of Home. Renders nothing when no
// sponsor is set for the current month.

import { useEffect, useState } from 'react';
import { Heart, ExternalLink } from 'lucide-react';
import { sponsorsAPI } from '../api/client';
import type { Sponsor } from '../types';

export default function SponsorBanner() {
  const [sponsor, setSponsor] = useState<Sponsor | null>(null);

  useEffect(() => {
    let active = true;
    sponsorsAPI
      .getCurrent()
      .then((res) => {
        if (active) setSponsor(res.sponsor);
      })
      .catch(() => {
        // Non-blocking: if the check fails we simply don't show the banner.
      });
    return () => {
      active = false;
    };
  }, []);

  if (!sponsor) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-xl px-4 py-2.5">
      <div className="flex items-center gap-3">
        {sponsor.logo ? (
          <img
            src={sponsor.logo}
            alt={`${sponsor.name} logo`}
            className="w-8 h-8 rounded-md object-contain bg-off-white flex-shrink-0"
          />
        ) : (
          <div className="w-8 h-8 bg-off-white rounded-md flex items-center justify-center flex-shrink-0">
            <Heart className="text-navy" size={14} />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-medium text-gray-400 uppercase tracking-wider">
            This month’s sponsor
          </p>
          <p className="text-navy font-medium text-sm leading-snug truncate">{sponsor.name}</p>
        </div>
        {sponsor.link_url && (
          <a
            href={sponsor.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-navy hover:underline whitespace-nowrap shrink-0"
          >
            Learn more
            <ExternalLink size={12} />
          </a>
        )}
      </div>
    </div>
  );
}
